import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolTip: {
      fontSize: theme.typography.body1.fontSize,
    },
    primary: {
      display: 'inline-grid',
      gridTemplateColumns: '1fr auto',
      gridGap: '.5rem',
      alignItems: 'center',
      margin: '0 12px',
      color: theme.palette.error.main,
    },
    primary__icon: {},
    secondary: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: 30,
      top: 5,
      right: 105,
      position: 'absolute',
      color: theme.palette.error.main,
      fontSize: theme.typography.caption.fontSize,
      zIndex: theme.zIndex.mobileStepper,
    },
    secondary__icon: {
      fontSize: '15px',
    },
    stacked: {
      width: '20px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      textAlign: 'center',
      color: theme.palette.error.main,
    },
    stacked__icon: {
      fontSize: '20px',
    },
  })
);
